import {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  Ref,
  createRef,
} from 'react';
import './redirection-modal.scss';
import { Dialog, DialogContent, Box } from '@mui/material';
import {
  APP_TYPE,
  dispatch,
  getAppType,
  getToken,
  getUserData,
  getWorkspaceId,
  logOut,
  updateAppType,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { SpinnerLoader } from '../../components';
import { getConfigValue, getQueryParams } from '@zonofi/common/functions';
import { RedirectionModalRef } from '../../types';

const FIELD_OPS = getConfigValue('FIELD_OPS');
const SELLER_HUB = getConfigValue('SELLER_HUB');

export const redirectionModalRef = createRef<RedirectionModalRef>();

export const RedirectionModal = forwardRef(
  (props: {}, ref: Ref<RedirectionModalRef>) => {
    const [open, setOpen] = useState(false);

    const appType = useAppSelector(getAppType);
    const accessToken = useAppSelector(getToken);
    const workspaceId = useAppSelector(getWorkspaceId);
    const userData = useAppSelector(getUserData);

    useImperativeHandle(ref, () => ({
      openRedirectionModal: () => {
        setOpen(true);
      },
    }));

    useEffect(() => {
      if (!open || !accessToken || !workspaceId) return;

      const timeout = setTimeout(() => {
        const baseUrl =
          appType === APP_TYPE.SELLER_HUB
            ? `${FIELD_OPS}/customers`
            : `${SELLER_HUB}/conversations`;
        const encodedData = btoa(JSON.stringify(userData));

        const queryParams = {
          token: accessToken,
          sellerWorkspaceId: workspaceId,
          userData: encodedData,
        };

        const redirectUrl = `${baseUrl}?${getQueryParams(queryParams)}`;

        dispatch(logOut());
        dispatch(updateAppType(appType));

        window.location.replace(redirectUrl);
      }, 2000);

      return () => clearTimeout(timeout);
    }, [open, appType, accessToken, workspaceId]);

    return (
      <Dialog
        open={open}
        fullScreen
        PaperProps={{
          sx: { backgroundColor: '#f0f0f0', display: 'flex' },
        }}
      >
        <DialogContent sx={{ p: 0, display: 'flex', flex: 1 }}>
          <Box className="redirect-modal-wrapper">
            <div className="redirect-modal-content">
              <SpinnerLoader color="#32A7E8" size={48} />

              <div className="redirect-modal-content--title font-semibold">
                {`Redirecting to ${
                  appType === APP_TYPE.SELLER_HUB ? 'Fieldops' : 'Sellerhub'
                }`}
              </div>

              <div className="redirect-modal-content--title font-regular">
                {'You’ll be redirected in just a moment...'}
              </div>
            </div>
          </Box>
        </DialogContent>
      </Dialog>
    );
  }
);
